import templateUrl from './bigPandaIntegration.html';

angular.module('sfx.ui').component('sfxBigPandaIntegration', {
    templateUrl,
    bindings: {
        credential: '<',
        sharedCredentialState: '<',
        integrationForm: '<',
        editable: '<',
        orgId: '<',
        obfuscatedText: '<',
    },
    controller: [
        '$scope',
        'notificationService',
        function ($scope, notificationService) {
            const $ctrl = this;

            $ctrl.$onInit = reset;

            function reset() {
                if (!$ctrl.credential.name) {
                    $ctrl.credential.name = 'BigPanda';
                }

                $ctrl.sharedCredentialState.updateCredentials = false;
                $ctrl.lastModifiedTs = notificationService.formatNotificationEventTimestamp(
                    $ctrl.credential.lastUpdated
                );
            }

            $scope.$on('reset', reset);
            $scope.$watchGroup(['$ctrl.credential.appKey', '$ctrl.credential.token'], function () {
                $ctrl.sharedCredentialState.updateCredentials = true;
            });
        },
    ],
});
